import {SafeLocalStorage} from "../utilities/SafeLocalStorage"

export const useNotificationsTimeThreshold = () => {
    const getValue = () => {
        return Number(SafeLocalStorage.getItem("notificationsThreshold")) || 0
    }
    const setValue = (value: number | undefined) => {
        if (value) {
            const currentValue = getValue()
            if (value > currentValue)
                SafeLocalStorage.setItem("notificationsThreshold", value.toString())
        } else SafeLocalStorage.removeItem("notificationsThreshold")
    }

    return {
        getValue,
        setValue,
    }
}
